import { CancelButton, SaveButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from '@core/components/Dialog';
import { cancelarAlert } from 'app/services/alerts';
import { FormikProvider, useFormik } from 'formik';
import moment from 'moment';
import React, { useEffect } from 'react';
import { ContratoAction, useContrato } from '../../store';
import ContratoBuscaAvancadaForm from './ContratoBuscaAvancadaForm';

const ContratoBuscaAvancadaModal = () => {
  const [state, dispatch] = useContrato();

  const { buscaAvancada, filtroAvancado, requestParams } = state;

  const handleCancelar = () => {
    if (formik.dirty) {
      cancelarAlert({
        confirmar: () => ContratoAction.fecharModalCadastro(dispatch),
      });
    } else {
      ContratoAction.fecharModalCadastro(dispatch);
    }
  };

  const handleSubmit = (values) => {
    if (values?.dataVigencia) {
      values.dataVigencia = moment(values.dataVigencia).format('YYYY-MM-DD');
    }

    ContratoAction.setFiltroAvancado(dispatch, values);
    ContratoAction.fecharModalCadastro(dispatch);
    ContratoAction.carregarRegistros(dispatch, requestParams, values);
  };

  const formik = useFormik({
    initialValues: filtroAvancado,
    onSubmit: handleSubmit,
  });

  useEffect(() => {
    if (buscaAvancada) {
      formik.resetForm(filtroAvancado);
    }
    // Reset controlado pelo gatilho acima; incluir o formulário/valores reiniciaria o
    // preenchimento enquanto o usuário edita.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buscaAvancada]);

  return (
    <SimpleDialog open={buscaAvancada} onClose={handleCancelar}>
      <FormikProvider value={formik}>
        <FormDialogContent
          onSubmit={formik.handleSubmit}
          header={{
            title: 'Busca Avançada',
            toolbar: (
              <>
                <CancelButton title="cancelar" type="button" onClick={handleCancelar}>
                  Cancelar
                </CancelButton>
                <SaveButton color="buttonSave" type="submit">
                  Aplicar
                </SaveButton>
              </>
            ),
          }}
          content={<ContratoBuscaAvancadaForm />}
          contentStyle={{ padding: 0 }}
        />
      </FormikProvider>
    </SimpleDialog>
  );
};

export default ContratoBuscaAvancadaModal;
